module.exports = __webpack_public_path__ + "static/media/helpdesk.7a842b03.png";